import React from "react";
import "./header.css";

const Header = () => {
  return (
    <header className="heads">
      <h1>Movie-Board</h1>
    </header>
  );
};
export default Header;
